export default "__VITE_ASSET__8d2d4fa9__"